import { dialog } from '@senet-uiverse/common';

import { DocumentDialogData } from './document-dialog.component';

export const loadDocumentDialog = () => import('./document-dialog.component');

export const documentDialog = () => {
  const dialogFn = dialog();

  const open = ({
    context,
    isClosable,
    successOnly,
  }: {
    context: Readonly<DocumentDialogData>;
    isClosable?: boolean;
    successOnly?: boolean;
  }) => {
    return dialogFn.open({
      component: loadDocumentDialog(),
      successOnly: successOnly,
      isObservable: true,
      config: {
        closeOnBackdropClick: isClosable,
        closeOnEsc: isClosable,
        context,
      },
    });
  };

  return {
    openWithConfirmation: (context: Readonly<DocumentDialogData>) => {
      return open({ context: { ...context, hasCloseButton: false }, isClosable: false, successOnly: true });
    },
    open: (context: Readonly<DocumentDialogData>, isClosable = true, successOnly = false) =>
      open({ context, isClosable, successOnly }),
  };
};
